import { BuildingConfig, BuildingConfigService, CanonicalPoint } from './BuildingConfigService';

export interface PointScope {
  equipmentId?: string;
  floorId?: string;
  spaceId?: string;
}

const matchesScope = (point: CanonicalPoint, scope: PointScope) =>
  (!scope.equipmentId || point.equipmentId === scope.equipmentId)
  && (!scope.floorId || point.floorId === scope.floorId)
  && (!scope.spaceId || point.spaceId === scope.spaceId);

export class PointRegistryService {
  static all(config: BuildingConfig = BuildingConfigService.get()): CanonicalPoint[] {
    return Object.values(config.points ?? {});
  }

  static byRole(role: string, scope: PointScope = {}, config: BuildingConfig = BuildingConfigService.get()): CanonicalPoint[] {
    return this.all(config)
      .filter(point => point.canonicalRole === role && matchesScope(point, scope))
      .sort((a, b) => (b.confidence ?? 0) - (a.confidence ?? 0));
  }

  static resolve(role: string, scope: PointScope = {}, fallback?: string, config: BuildingConfig = BuildingConfigService.get()): string | undefined {
    const scoped = this.byRole(role, scope, config)[0];
    if (scoped) return scoped.sourcePointId;
    const hasScope = Boolean(scope.equipmentId || scope.floorId || scope.spaceId);
    return (hasScope ? this.byRole(role, {}, config)[0]?.sourcePointId : undefined) || fallback;
  }

  static resolveMany(role: string, scope: PointScope = {}, config: BuildingConfig = BuildingConfigService.get()): string[] {
    return [...new Set(this.byRole(role, scope, config).map(point => point.sourcePointId))];
  }

  static findBySource(sourcePointId: string, config: BuildingConfig = BuildingConfigService.get()): CanonicalPoint[] {
    return this.all(config).filter(point => point.sourcePointId === sourcePointId);
  }
}
